import { cloneDeep, compact, clone, keys, isArray } from 'lodash';
import Tweens from './tweens.js';
require('./moonshine.min.js');

function LuaVm(props, systems) {
  props.setProperty = (prop, value) => {
    this.setProperty(prop, value);
  }
  props.debugLog = (ent, multiScriptComponent, line, type) => {
    console.log('debug log', ent, line);
    this.systems.gameobjects.debugLog({
      ent,
      component:multiScriptComponent,
      type,
      line
    });
  }
  props.destroyScriptComponent = (ent, multiScriptComponent) => {
    multiScriptComponent.__toDestroy = true;
  }
  props.emitSlot = (ent, multiScriptComponent, slotName) => {
    if (!multiScriptComponent.slotActivated) {
      multiScriptComponent.slotActivated = [];
    }
    console.log('ADDD SLOT!!!', slotName);
    multiScriptComponent.slotActivated.push(slotName);
  }
  props.emitEvent = (ent, eventName) => {
    this.systems.gameobjects.emitEvent({eventName});
  }
  props.setTransformProperty = (ent, propName, val) => {
    this.systems.setDirty(ent);
    switch (propName) {
      case 'x': ent.transform.x = val; ent.transform.__positionUpdated = true; break;
      case 'y': ent.transform.y = val; ent.transform.__positionUpdated = true; break;
      case 'scalex': ent.transform.localScale.x = val; break;
      case 'scaley': ent.transform.localScale.y = val; break;
      case 'rotation': ent.transform.rotation = val; break;
      case 'alpha': ent.transform.alpha = val; break;
      case 'zIndex': ent.transform.zIndex = val; break;
    }
  }

  props.getTransformProperty = (ent, propName) => {
    switch (propName) {
      case 'x': 
        if (ent.physicsbody) {
          //throw new Error('a');
          return systems.getPhysicsPosition(ent).x;
        } else {
          return ent.transform.x; 
        }
        break;
      case 'y': 
        if (ent.physicsbody) {
          //throw new Error('a');
          return systems.getPhysicsPosition(ent).y;
        } else {
          return ent.transform.y; 
        }
        break;
      case 'scalex': return ent.transform.localScale.x; break;
      case 'scaley': return ent.transform.localScale.y; break;
      case 'rotation': return ent.transform.rotation; break;
      case 'alpha': ent.transform.alpha = val; break;
      case 'zIndex': return ent.transform.zIndex; break;
      case 'velocity_x':
        if (ent.physicsbody) {
          //throw new Error('a');
          return systems.getPhysicsLinearVelocity(ent).x;
        } else {
          console.error('not a physicsbody');
          return 0;
        }
        break;
      case 'velocity_y':
        if (ent.physicsbody) {
          //throw new Error('a');
          return systems.getPhysicsLinearVelocity(ent).y;
        } else {
          console.error('not a physicsbody');
          return 0;
        }
        break;
    }
  }
  props.applyTween = (tweenName, from, to, duration, t) => {
    const tweenFunc = Tweens[tweenName];
    const v = tweenFunc(Math.min(t/duration,1), 0, 1, 1);
    return from + (to-from)*v;
  }
  props.gotoScene = (ent, eventName) => {
    throw new Error('do the work');
  }
  props.addDebug = (ent, line) => {
    this.systems.gameobjects.addDebug(line);
  }
  props.toast = (line, type) => {
    this.systems.gameobjects.doToast(line,type);
  }

  this.systems = systems;
  this.vm = new shine.VM(props);
  this.props = this.vm._globals;
  this.scriptsRunning = {};
}

LuaVm.prototype.load = function (system) {
  return new LuaSystem(this.vm, cloneDeep(system), this.systems, this.props, this);
}

LuaVm.prototype.setProperty = function (prop, value) {
  this.props[prop] = value;
}

LuaVm.prototype.tableToList = function (table) {
  if (!table.__shine) {
    return table;
  } else if (compact(table.__shine.numValues).length> 0) {
    return compact(clone(table.__shine.numValues));
  } else {
    const o = {};
    keys(table).forEach( (k,i) => {
      if (k.indexOf('__') !== 0) {
        o[k] = table[k];
      }
    });
    return [o]
  }
}
LuaVm.prototype.objectToTable = function (o) {
  return new shine.Table(o);
}
LuaVm.prototype.listToTable = function (lst) {
  return new shine.Table(lst);
}

function LuaSystem(vm, system, systems, props, main) {
  this.vm = vm;
  this.system = system;
  this.systems = systems;
  this.props = props;
  this.main = main;
  if (!isArray(system.lua.functions[0].instructions)) {
    this.props.toast('script problem: ' + system.id, 'error');
  }
  this.vm.load(system.lua);
  const funcName = `func_${system.id.replace(/-/g, '_')}`;
  this.func = this.vm.getGlobal(funcName);
}

LuaSystem.prototype.prepareGlobalAndLocalVariables = function (ent, scriptComponent) {
  const props =this.systems.getProperties(ent);
  for (let i = 0; i < (scriptComponent.internalVariables||[]).length; i++) {
    const v = scriptComponent.internalVariables[i];
    delete this.vm._globals[v];
    //if (!ent.props) {
      //ent.props = {};
    //}
    //ent.props[variable] = this.vm._globals[variable];
  }
  keys(ent.uuid.__internalVariables).forEach( (k) => {
    this.vm._globals[k] = ent.uuid.__internalVariables[k];
  });
  keys(props).forEach( (k) => {
    this.vm._globals[k] = props[k];
  });

}

LuaSystem.prototype.postGlobalAndLocalVariables = function (ent, scriptComponent) {
  for (let i = 0; i < (scriptComponent.internalVariables||[]).length; i++) {
    const variable = scriptComponent.internalVariables[i];
    ent.uuid.__internalVariables[variable] = this.vm._globals[variable];
  }
}

LuaVm.prototype.cleanupScript = function (ent, scriptComponent) {
  this.scriptsRunning[`${ent.uuid.uuid}-${scriptComponent.script.id}`] = false;
  for (let i = 0; i < (scriptComponent.internalVariables||[]).length; i++) {
    const variable = scriptComponent.internalVariables[i];
    console.log('clear scirpt variable', variable.name, variable.id_);
    delete this.vm._globals[variable];
    delete this.vm._globals[variable.name];
    //this.vm._globals[variable] = null;
    //delete this.vm._globals[variable];
  }
}



LuaSystem.prototype.run = function (dt, ent, multiScriptComponent, script) {
  if (!script) {
    script = multiScriptComponent.script;
  }
  this.main.scriptsRunning[`${ent.uuid.uuid}-${script.id}`] = true;
  this.prepareGlobalAndLocalVariables(ent, multiScriptComponent);
  if (this.func) {
    try {

      const ret = this.func.call(this.func, dt, ent, multiScriptComponent);
      this.systems.updateGlobalAndLocalVariables(ent, this.vm._globals);
      this.postGlobalAndLocalVariables(ent, multiScriptComponent)
      return ret;
    } catch (e) {
      console.error('script broken', e);
      throw e;
    }
  } else {
    throw new Error('no func for: ' + JSON.stringify(multiScriptComponent.type))
    return []
  }
}


export default LuaVm
